import actions from './actions';

const initState = {
    clients: [],
    pharmacies: [],
    unassignedPharmacies: [],
    settings: [],
    errors: {},
    loading: false,
    clientInfo: {},
    editView: false,
    clientsByAccount:[],
    loadingClientsByAccount: false
};
let newClients = [];
export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_CLIENTS:
            return {
                ...state,
                clients: [],
                clientInfo: {},
                loading: true,
                editView: false,
            };
        case actions.FETCH_CLIENTS_SUCCESS:
            return {
                ...state,
                clients: [...action.clients],
                pharmacies: action.pharmacies,
                allClients: action.retrieveAll ? action.clients : state.allClients,
                loading: false,
                editView: false,
            };
        case actions.FETCH_UNASSIGNED_PHARMACIES_SUCCESS:
            return {
                ...state,
                unassignedPharmacies: action.pharmacies,
            };
        case actions.FETCH_SETTINGS:
            return {
                ...state,
                loading: true,
            };
        case actions.FETCH_SETTINGS_SUCCESS:
            return {
                ...state,
                settings: action.settings,
                loading: false,
            };
        case actions.GET_CLIENT:
            return {
                ...state,
                loading: true,
                editView: false,
            };
        case actions.GET_CLIENT_SUCCESS:
            return {
                ...state,
                clientInfo: action.client,
                loading: false,
                editView: false,
            };
        case actions.ADD_CLIENT:
            return {
                ...state,
                editView: true,
            };
        case actions.EDIT_CLIENT_VIEW:
            return {
                ...state,
                editView: action.view,
                clientInfo: (state.clientInfo && state.clientInfo.clientId) ? { ...state.clientInfo } : {},
            };
        case actions.ADD_CLIENT_VIEW:
            return {
                ...state,
                editView: action.view,
                clientInfo: null,
            };
        case actions.SAVE_CLIENT:
            return {
                ...state,
                loading: true,
                clientInfo: {},
                editView: action.view,
            };
        case actions.SAVE_CLIENT_SUCCESS:
            return {
                ...state,
                loading: false,
                editView: false,
                clientInfo: action.client,
            };
        case actions.SAVE_CLIENT_ERROR:
            return {
                ...state,
                loading: false,
                editView: false,
            };
        case actions.UPDATE_VALUES:
            return {
                ...state,
                clientInfo: {
                    ...state,
                    clientInfo: action.clientInfo
                },
            };
        case actions.DELETE_CLIENT_SUCCESS:
            newClients = state.clients.filter((client) => client.clientId !== action.clientId)
            return {
                ...state,
                clients: newClients,
                clientInfo: {},
                editView: false,
            };
        case actions.FETCH_CLIENTS_BY_ACCOUNT:
            return {
                ...state,
                clientsByAccount: [],
                loadingClientsByAccount: true
            };
        case actions.FETCH_CLIENTS_BY_ACCOUNT_SUCCESS:
            return {
                ...state,
                clientsByAccount: [...action.clients],
                loadingClientsByAccount: false,
            };
        default:
            return state;
    }

}
